(function () {
    'use strict';

    angular.module('common')
        .service('PDFService', PDFService);

    PDFService.$inject = ['$http'];

    function PDFService($http) {
        var self = this;

        self.download = download;

        return self;

        /**
         * Downloads PDF from a URL.
         *
         * @param url the URL that generates the PDF response
         * @param filename the name the file should have when it is downloaded
         * @param callback invoked with null on success, or error on failure
         */
        function download(url, filename, callback) {
            $http.get(url, {
                responseType: 'arraybuffer'
            }).then(
                function success(response) {
                    var pdfFile = new Blob(
                        [response.data],
                        {
                            type : 'application/pdf'
                        }
                    );
                    let downloadURL = URL.createObjectURL(pdfFile);
                    let link = document.createElement('a');
                    link.href = downloadURL;
                    link.download = filename;
                    link.click();

                    callback(null);
                },
                function fail(error) {
                    callback(error);
                });
        }
    }
})();